import React from 'react'
import PropTypes from 'prop-types'
import { isLoaded } from 'react-redux-firebase'
import moment from 'moment'
import { getWeeks } from '../../helpers/helpers'
import Weekly from '../Weekly/Weekly'
import WeeklySummary from '../WeeklySummary/WeeklySummary'
import SelectMonth from '../SelectMonth/SelectMonth'
import SelectYear from '../SelectYear/SelectYear'
import AddProject from '../../containers/AddProject'
import Spinner from '../Spinner/Spinner'
import { setDate } from '../../helpers/helpers'
import Calendar from './Calendar'

import './Timesheet.css'

const DatePicker = ({ currentDate, selectMonth}) => {
  return (
    <div className='timesheet-date-wrapper'>
      <div className='timesheet-date-wrapper__item'>
        <SelectYear />
      </div>
      <div className='timesheet-date-wrapper__item'>
        <SelectMonth date={currentDate} selectMonth={selectMonth} />
      </div>
    </div>
  )
}

DatePicker.propTypes = {
  currentDate: PropTypes.obj,
  selectMonth: PropTypes.func
}

const Timesheet = ({
  profile,
  projects,
  timesheets,
  updateTimeSheet,
  selectMonth,
  currentMonth
}) => {
  const currentDate = moment(setDate(new Date(currentMonth)))

  if (!isLoaded(profile)) return <Spinner />
  if (isLoaded(projects) && !projects) return <AddProject />
  if (isLoaded(profile) && !profile.selectedProject && isLoaded(projects))
    return (
      <div>
        You must select a project
      </div>
    )

  if (isLoaded(projects) && isLoaded(timesheets) && profile.selectedProject) {
    const loadedTimesheet = !timesheets ? {} : timesheets
    return (
      <div className='app-content'>
        <header className='timesheet-header'>
          <h3 className='timesheet-title'>
          <Calendar />
            Weekly Timesheet
          </h3>
          <DatePicker currentDate={currentDate} selectMonth={selectMonth} />
        </header>
        <Weekly
          date={currentDate}
          weeks={getWeeks(currentDate)}
          timeSheet={loadedTimesheet[profile.selectedProject]}
          updateTimeSheet={updateTimeSheet}
          selectMonth={selectMonth}
        />
        <WeeklySummary
          date={currentDate}
          timeSheet={loadedTimesheet[profile.selectedProject]}
        />
      </div>
      
    )
  }

  return (
    <div className='container'>
      <header>
        <h1>Time Report</h1>
        <AddProject />
      </header>
    </div>
  )
}

Timesheet.propTypes = {
  profile: PropTypes.object.isRequired,
  projects: PropTypes.objectOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      rate: PropTypes.string.isRequired
    }).isRequired
  ),
  timesheets: PropTypes.object,
  updateTimeSheet: PropTypes.func,
  selectMonth: PropTypes.func,
  currentMonth: PropTypes.string
}

export default Timesheet



// WEBPACK FOOTER //
// ./src/components/Timesheet/Timesheet.js